"use client";
import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { memo as g } from "react";
import { Box as n } from "../../base/Base.js";
import { Button as r } from "../../../buttons/button/Button.js";
import '../../../assets/PlateCookies.css';const m = "_plate_vsgb9_1", b = "_text_vsgb9_19", p = "_white_vsgb9_32", u = "_violet_vsgb9_37", v = "_orange_vsgb9_42", x = "_gray_vsgb9_47", d = "_red_vsgb9_52", h = "_notice_vsgb9_57", w = "_button_vsgb9_64", t = {
  plate: m,
  text: b,
  white: p,
  violet: u,
  orange: v,
  gray: x,
  red: d,
  notice: h,
  button: w
}, y = g(
  ({
    text: a,
    buttonTextSelect: _,
    buttonTextAccept: c,
    isMobile: o,
    onSelect: l,
    onAccept: i
  }) => /* @__PURE__ */ s(n, { gap: 16, className: t.plate, children: [
    /* @__PURE__ */ e("span", { className: t.text, children: a }),
    /* @__PURE__ */ s(n, { gap: 12, children: [
      /* @__PURE__ */ e(
        r,
        {
          text: c,
          size: o ? "large" : "normal",
          wide: !0,
          centerText: !0,
          className: t.button,
          onClick: i
        }
      ),
      /* @__PURE__ */ e(
        r,
        {
          text: _,
          size: o ? "large" : "normal",
          wide: !0,
          centerText: !0,
          color: "outline",
          className: t.button,
          onClick: l
        }
      )
    ] })
  ] })
);
y.displayName = "PlateCookies";
export {
  y as PlateCookies
};
